export default __webpack_public_path__ + "static/ieee_bridge_issue3_2021-c6d713aa19776fb6230d12d6ff10a529.webp";